export const formatNumber = async (numberValue) => {
  let formattedNumber = numberValue.toString().trim();

  if(formattedNumber?.includes(",")) {
    formattedNumber = formattedNumber.replace(",",".");
  }

  return Number(formattedNumber);
}